import React, { useContext, useMemo } from 'react';
import { useField } from 'react-final-form';
import { SelectField } from '@ubeya/shared-web/components';
import useCRM from '@ubeya/shared/hooks/account/useCRM';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const BlockedClientsSelectField = ({ name = 'blockedClients', title, isMulti = false, ...restSelectProps }) => {
  const { t } = useContext(ConfigContext);

  const { clients } = useCRM();
  const {
    input: { value: preferredClients }
  } = useField('preferredClients');

  const options = useMemo(() => {
    return clients
      .filter(({ id }) => !preferredClients.includes(id))
      .filter(({ isDeleted }) => !isDeleted)
      .map((client) => ({ value: client.id, label: client.name }));
  }, [preferredClients, clients]);

  if (options?.length === 0) {
    return null;
  }

  return (
    <SelectField
      name={name}
      title={title ?? t('blockedClients')}
      options={options}
      usePortal
      isMulti={isMulti}
      {...restSelectProps}
    />
  );
};

export default BlockedClientsSelectField;
